import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { API_RESOURCE } from '@/constants/api.constant'
import useAction from '@/hooks/useAction'
import { useCrud } from '@/hooks/useCrud'
import { camelToWords } from '@/utils/stringHelper'
import ConfigService from './config.service'
import { createQueryKey } from '@/lib/react-query'

const useConfig = () => {
  const queryClient = useQueryClient()
  const queryKey = createQueryKey(API_RESOURCE.CONFIG)

  const useFetchConfigByType = (type) => {
    return useQuery({
      queryKey: [queryKey.details(), type],
      queryFn: () => ConfigService.fetchConfigByType(type),
      placeholderData: keepPreviousData,
    })
  }

  return {
    //Extra
    useFetchConfigByType,
  }
}

export default useConfig
